module.exports = __webpack_public_path__ + "static/media/47.afb9ba39.jpg";